export default __webpack_public_path__ + "static/media/jolt-65-7.fee592e0.jpg";